import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ComslowComponent } from './components/network/comslow/comslow.component';
import { DriverMacComponent } from './components/network/driver-mac/driver-mac.component';
import { MonitorMacComponent } from './components/network/monitor-mac/monitor-mac.component';
import { NasMacComponent } from './components/network/nas-mac/nas-mac.component';
import { PageCalendarComponent } from './components/network/page-calendar/page-calendar.component';
import { PageComputerproblemComponent } from './components/network/page-computerproblem/page-computerproblem.component';
import { PageDataComponent } from './components/network/page-data/page-data.component';
import { PageDatagoogleComponent } from './components/network/page-datagoogle/page-datagoogle.component';
import { PageDataonedriveComponent } from './components/network/page-dataonedrive/page-dataonedrive.component';
import { PageDrivemaxComponent } from './components/network/page-drivemax/page-drivemax.component';
import { PageFilegoogleComponent } from './components/network/page-filegoogle/page-filegoogle.component';
import { PageInternetLANComponent } from './components/network/page-internet-lan/page-internet-lan.component';
import { PageInternetWifiComponent } from './components/network/page-internet-wifi/page-internet-wifi.component';
import { PageInternetComponent } from './components/network/page-internet/page-internet.component';
import { PageNasComponent } from './components/network/page-nas/page-nas.component';
import { PagePrintInternetComponent } from './components/network/page-print-internet/page-print-internet.component';
import { PagePrinterDriverComponent } from './components/network/page-printer-driver/page-printer-driver.component';
import { PagePrinterComponent } from './components/network/page-printer/page-printer.component';
import { PageUpdatewindowsComponent } from './components/network/page-updatewindows/page-updatewindows.component';
import { PageUsenasComponent } from './components/network/page-usenas/page-usenas.component';
import { PageWhteNasComponent } from './components/network/page-whte-nas/page-whte-nas.component';
import { UsefileComponent } from './components/network/usefile/usefile.component';
import { PageHomeComponent } from './components/page-home/page-home.component';
import { NasmacComponent } from './nasmac/nasmac.component';

const routes: Routes = [
  { path: 'home', component: PageHomeComponent},
  { path: 'drivermac', component: DriverMacComponent},
  { path: 'monitormac', component: MonitorMacComponent},
  { path: 'nasm', component: NasMacComponent},
  { path: 'internet', component: PageInternetComponent},
  { path: 'whatnas', component: PageWhteNasComponent},
  { path: 'nas', component: PageNasComponent},
  { path: 'usenas', component: PageUsenasComponent},
  { path: 'lan', component: PageInternetLANComponent},
  { path: 'wifi', component: PageInternetWifiComponent},
  { path: 'updatewindows', component: PageUpdatewindowsComponent},
  { path: 'comproblem', component: PageComputerproblemComponent},
  { path: 'filegoogle', component: PageFilegoogleComponent},
  { path: 'comslow', component: ComslowComponent},
  { path: 'drivemax', component: PageDrivemaxComponent},
  { path: 'usefile', component: UsefileComponent},
  { path: 'printer', component: PagePrinterComponent},
  { path: 'printerinternet', component: PagePrintInternetComponent},
  { path: 'printerdriver', component: PagePrinterDriverComponent},
  { path: 'dataonedrive', component: PageDataonedriveComponent},
  { path: 'datagoogle', component: PageDatagoogleComponent},
  { path: 'data', component: PageDataComponent},
  { path: 'calendar', component: PageCalendarComponent},
  { path: '**', component: PageHomeComponent },
  { path: '',   redirectTo: '/home', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
